import React, { useState, useEffect } from "react";
import ButtonComponent from "../../components/button";
import useInitFcmRegisterProcess from "../../utils/registerFcmPushNotificationsForOrderActivities";

const FcmNotificationPermissionPopup = ({ id, shop }) => {
  const [showPermissionButton, setShowPermissionButton] = useState(false);
  const [shouldInitFcm, setShouldInitFcm] = useState(false);

  useEffect(() => {
    if (!("Notification" in window)) {
      console.warn("Browser does not support notifications.");
      return;
    }

    console.log("Notification permission: "+ Notification.permission);

    if (Notification.permission === "default") {
      localStorage.removeItem("sc_pn_fcmTokenSent");

      //user hasn't decided yet
      setShowPermissionButton(true);

      setTimeout(function(){
        const modalEl = document.getElementById('enableFcmNotificationModal');
        const myModal = new window.bootstrap.Modal(modalEl);
        myModal.show();
      }, 1500);
    }
  }, []);

  useInitFcmRegisterProcess(shouldInitFcm ? id : null, shouldInitFcm ? shop : null);

  const enableNotifications = async () => {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      setShowPermissionButton(false); //hide button after granted

      setShouldInitFcm(true);
    } else {
      console.log("Notifications were blocked or denied.");
      setShowPermissionButton(false); //hide if denied too
    }

    const modalEl = document.getElementById('enableFcmNotificationModal');
    const myModal = window.bootstrap.Modal.getInstance(modalEl);
    if (myModal) {
      myModal.hide();
    }
  };

  return (
    <>
      {showPermissionButton && (
        <div>
          <div className="modal fade" id="enableFcmNotificationModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="enableFcmNotificationModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="notification-bell alarm-notify">
                    <svg className="bell-con" viewBox="0 0 448 512" width="50" title="Enable notifications">
                      <path d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z" />
                        <defs>
                          <linearGradient id="fillGradient">
                          <stop offset="0%" stopColor="#962BF8" stopOpacity="0.3"></stop>
                          <stop offset="50%" stopColor="#962BF8" stopOpacity="0.6"></stop>
                          <stop offset="100%" stopColor="#962BF8" stopOpacity="1"></stop>
                          </linearGradient>
                        </defs>
                    </svg>
                  </div>

                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body text-center">
                  <p className="mt-3 mb-4">Would you like to receive updates on this transaction? Tap the button below to enable push notifications 🔔 and get real-time updates! 😎</p>
                  
                  <ButtonComponent
                    type="button"
                    id="next_btn"
                    className="btn btn-primary btn-pool-no-background"
                    label="Keep me updated"
                    size="md"
                    variant="primary"
                    onClick={enableNotifications}
                  ></ButtonComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FcmNotificationPermissionPopup;
